/* Sanki — Polish layer (Jun 2026) v3 — single break
   ----------------------------------------------------------
   Two micro-features bundled into one tiny asset:

   1. MID-GRID EDITORIAL BREAK — inserts a full-width editorial
      banner into the collection grid every 12 products. Breaks
      the visual monotony of a long catalog. Uses the same banner
      assets the page-banner snippet uses (sanki-banner-1.jpg).

   2. SUBTLE SOUND DESIGN — soft click sound on add-to-cart,
      gentle whoosh on cart drawer open. Honors
      prefers-reduced-motion + a user-toggleable mute (stored in
      localStorage as `sk_sound_off`). All sounds are tiny synth-
      generated via Web Audio API (no asset downloads).
*/
(function () {
  if (window.__sk_polish) return;
  window.__sk_polish = true;

  // ───── 1. EDITORIAL BREAKS ────────────────────────────────────
  function injectBreaks() {
    return; // disabled per user request — no editorial banners outside home

    var grid = document.querySelector('[data-sk-products-grid]');
    if (!grid) return;

    var quotes = [
      'Designed for the day you say yes to yourself.',
      'Small cuts. Long lives. Loud presence.',
      'A little crazy. A lot considered.',
      'Wear it like you mean it.',
    ];
    var images = [
      '/cdn/shop/t/43/assets/sanki-banner-1.jpg',
    ];

    var cards = Array.from(grid.children).filter(function (c) {
      return c.classList && c.classList.contains('sk-card-wrap') ||
             c.matches && (c.matches('[data-sk-card-wrap]') ||
                           c.querySelector && c.querySelector('.sk-card'));
    });

    if (cards.length < 20) return; // only worth breaking up long grids

    // De-duplicate — remove any existing breaks first (in case script
    // re-runs on hot reload or back-button restoration)
    grid.querySelectorAll('.sk-editorial-break').forEach(function (e) { e.remove(); });

    // Single break at row 4 (~product index 16 on a 4-col grid) — enough
    // to break the visual monotony without spamming the page.
    var pos = Math.min(16, Math.floor(cards.length / 2));
    var anchor = cards[pos];
    if (!anchor) return;

    var quote = quotes[Math.floor(Math.random() * quotes.length)];
    var img = images[0];
    var brk = document.createElement('div');
    brk.className = 'sk-editorial-break';
    brk.innerHTML = '<img class="sk-editorial-break__img" src="' + img +
      '" alt="" loading="lazy" decoding="async">' +
      '<div class="sk-editorial-break__overlay">' +
      '<p class="sk-editorial-break__quote">&ldquo;' + quote + '&rdquo;</p>' +
      '</div>';
    anchor.parentNode.insertBefore(brk, anchor);
  }

  // ───── 2. SOUND DESIGN ────────────────────────────────────────
  var soundOff = false;
  try { soundOff = localStorage.getItem('sk_sound_off') === '1'; } catch (e) {}
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    soundOff = true;
  }

  var audioCtx = null;
  function getCtx() {
    if (soundOff) return null;
    if (!audioCtx) {
      try {
        audioCtx = new (window.AudioContext || window.webkitAudioContext)();
      } catch (e) { soundOff = true; return null; }
    }
    return audioCtx;
  }

  function playClick() {
    var ctx = getCtx();
    if (!ctx) return;
    var now = ctx.currentTime;
    var osc = ctx.createOscillator();
    var gain = ctx.createGain();
    osc.type = 'sine';
    osc.frequency.setValueAtTime(880, now);
    osc.frequency.exponentialRampToValueAtTime(440, now + 0.05);
    gain.gain.setValueAtTime(0.001, now);
    gain.gain.exponentialRampToValueAtTime(0.12, now + 0.005);
    gain.gain.exponentialRampToValueAtTime(0.001, now + 0.08);
    osc.connect(gain).connect(ctx.destination);
    osc.start(now);
    osc.stop(now + 0.09);
  }

  function playWhoosh() {
    var ctx = getCtx();
    if (!ctx) return;
    var now = ctx.currentTime;
    var noise = ctx.createBufferSource();
    var buffer = ctx.createBuffer(1, ctx.sampleRate * 0.4, ctx.sampleRate);
    var data = buffer.getChannelData(0);
    for (var i = 0; i < data.length; i++) {
      data[i] = (Math.random() * 2 - 1) * Math.pow(1 - i / data.length, 2.5);
    }
    noise.buffer = buffer;
    var filter = ctx.createBiquadFilter();
    filter.type = 'bandpass';
    filter.frequency.setValueAtTime(800, now);
    filter.frequency.exponentialRampToValueAtTime(2400, now + 0.3);
    filter.Q.value = 0.8;
    var gain = ctx.createGain();
    gain.gain.setValueAtTime(0.001, now);
    gain.gain.exponentialRampToValueAtTime(0.06, now + 0.05);
    gain.gain.exponentialRampToValueAtTime(0.001, now + 0.4);
    noise.connect(filter).connect(gain).connect(ctx.destination);
    noise.start(now);
    noise.stop(now + 0.4);
  }

  // Wire up
  document.addEventListener('click', function (e) {
    var atc = e.target.closest('[data-sk-add-to-cart], [data-sk-mobile-atc-btn], [data-sk-quick-add]');
    if (atc && !atc.disabled) playClick();
    var cart = e.target.closest('[data-sk-glassnav-cart], [data-sk-cart-toggle]');
    if (cart) playWhoosh();
  });

  // Init
  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    setTimeout(injectBreaks, 200);
  } else {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(injectBreaks, 200); });
  }
})();
